import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import InstructionWrap from '../../../../components/InstructionWrap';

const Document = ({ i18n }) => {
  const pricelist = [
    {
      label: i18n('rates.tab1.pricelist.1.title'),
      price: i18n('rates.tab1.pricelist.1.price')
    },
    {
      label: i18n('rates.tab1.pricelist.2.title'),
      price: i18n('rates.tab1.pricelist.2.price')
    },
    {
      label: i18n('rates.tab1.pricelist.3.title'),
      price: i18n('rates.tab1.pricelist.3.price')
    },
    {
      label: i18n('rates.tab1.pricelist.4.title'),
      price: i18n('rates.tab1.pricelist.4.price')
    }
  ];

  return (
    <div className='card-instruction-detail'>
      <div className='rates'>
        <span style={{ fontSize: 14 }}>{i18n('rates.info1')}</span>
        {/* <div style={{ fontSize: 16, color: 'red' }}>{i18n('rates.info2')}</div> */}
      </div>
      <main>
        <InstructionWrap type='rates' rates={pricelist} />
      </main>
    </div>
  );
};

Document.propTypes = {
  i18n: PropTypes.func
};

const mapStateToProps = (state) => ({
  i18n: state.langReducer.i18n
});

export default connect(mapStateToProps)(Document);
